import DqInventorypanel from './src/inventorypanel'

/* istanbul ignore next */
DqInventorypanel.install = function (Vue) {
  Vue.component(DqInventorypanel.name, DqInventorypanel)
}

export default DqInventorypanel



// WEBPACK FOOTER //
// ./src/dq-ui/packages/inventorypanel/inventorypanel.js